// import assest from '@/json/assest';
import assest from "../../../json/assest";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogProps,
  List,
  Slide,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useMemo, useRef, useState } from "react";
// import styles from "@/styles/pages/home.module.scss";
import styles from "../../../styles/pages/home.module.scss";
import ExpensesAccordionBox from "./Fragments/ExpensesAccordionBox";
// import GlobalDialogTransition from "@/components/UtilitiesComponent/GlobalDialogTransition";
// import Image from 'next/image';
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import GlobalDialogTransition from "../../UtilitiesComponent/GlobalDialogTransition";
import { useQuery } from "react-query";
import { roleWiseExpense } from "../../../api/functions/user.api";

// export type ExpensesModalProps = DialogProps
export default function ExpensesModal(props) {
  const [roleId, setRoleId] = useState(null);
  const ref = useRef(null);
  const [roleWiseData, setRoleWiseData] = useState({
    membersList: [],
    partnerList: [],
    contentBuyerList: [],
  });
  const { monthName, month, year } = props?.selectedYearMonth;
  const roleWiseDataValidator = (data) => {
    if (roleId == 2) {
      setRoleWiseData({ ...roleWiseData, membersList: data });
    } else if (roleId == 3) {
      setRoleWiseData({ ...roleWiseData, partnerList: data });
    } else {
      setRoleWiseData({ ...roleWiseData, contentBuyerList: data });
    }
  };
  const { data: roleWiseExpenseData, isLoading } = useQuery(
    ["roleWiseExpenseData", year, roleId],
    (body) =>
      roleWiseExpense({
        ...body,
        month,
        year,
        role_id: roleId,
      }),
    { onSuccess: roleWiseDataValidator, enabled: !!roleId }
  );

  const roleIdHandler = (data) => setRoleId(data);
  const modalCloseHandler = () => {
    setRoleId(null);
    props.onClose;
  };
  console.warn("roleWiseExpense", roleWiseData);
  return (
    <Dialog
      fullScreen
      TransitionComponent={GlobalDialogTransition}
      onClose={modalCloseHandler}
      {...props}
      className={styles.homeblogmembers}
    >
      <AppBar sx={{ position: "relative" }} className={styles.header_modal}>
        <Box className={styles.expenses_year}>
          <Typography variant="h2">
            Expenses - {monthName} {year}
          </Typography>
          <Button
            autoFocus
            color="inherit"
            onClick={(e) => props?.onClose?.(e, "backdropClick")}
            className={styles.modal_cross_icon}
          >
            <CloseIcon />
          </Button>
        </Box>
      </AppBar>

      <Box className={styles.expensesModalScroll}>
        <PerfectScrollbar>
          <Box className={styles.modal_main_body1}>
            <Box className={styles.accordian_box} ref={ref}>
              <ExpensesAccordionBox
                ref={ref}
                isLoading={isLoading}
                roleIdHandler={() => roleIdHandler(2)}
                data={roleWiseData?.membersList ?? []}
                title="Members"
                image={
                  <img
                    src={assest.memberIconExpenses}
                    width={24}
                    height={16}
                    alt=""
                  />
                }
              />
              <ExpensesAccordionBox
                ref={ref}
                isLoading={isLoading}
                roleIdHandler={() => roleIdHandler(3)}
                data={roleWiseData?.partnerList ?? []}
                title="Partners"
                image={
                  <img
                    src={assest.partnerIconExpenses}
                    width={24}
                    height={19}
                    alt=""
                  />
                }
              />
              <ExpensesAccordionBox
                ref={ref}
                isLoading={isLoading}
                roleIdHandler={() => roleIdHandler(9)}
                data={roleWiseData?.contentBuyerList ?? []}
                title="Content buyers"
                image={
                  <img
                    src={assest.contentBuyerIconExpenses}
                    width={26}
                    height={24}
                    alt=""
                  />
                }
              />
            </Box>
          </Box>
        </PerfectScrollbar>
      </Box>
    </Dialog>
  );
}
